import { render, staticRenderFns } from "./zwlink.vue?vue&type=template&id=b9a2a7c0&scoped=true"
import script from "./zwlink.vue?vue&type=script&lang=js"
export * from "./zwlink.vue?vue&type=script&lang=js"
import style0 from "./zwlink.vue?vue&type=style&index=0&id=b9a2a7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a2a7c0",
  null
  
)

export default component.exports